/* unplugin-vue-components disabled */import script from "./cloudActivities.vue?vue&type=script&lang=ts&setup=true"
export * from "./cloudActivities.vue?vue&type=script&lang=ts&setup=true"

import "./cloudActivities.vue?vue&type=style&index=0&id=3c8cd44f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c8cd44f"]])

export default __exports__